<template>
  <div class="row">
    <div class="col-md">
      <dl class="dl-horizontal">
        <dt>id</dt>
        <dd>
          <router-link
            class="text-monospace text-muted"
            :to="`/receipts/${receipt.id}`"
          >{{receipt.id}}</router-link>
        </dd>

        <dt>modem_command_id</dt>
        <dd>
          <router-link
            class="text-monospace text-muted"
            :to="`/commands/${receipt.modem_command_id}`"
          >{{receipt.modem_command_id}}</router-link>
        </dd>
        <vue-json-pretty :data="receipt.request"/>
      </dl>
    </div>
    <div class="col-md text-monospace" v-if="receipt.response">{{receipt.response}}</div>
  </div>
</template>

<script>
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    components: {VueJsonPretty},
    props: {
      receipt: {
        type: Object,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/receipt-details.vue